import { ThemeProvider, createTheme } from "@mui/material";
import { useEffect, useState } from "react";

const primaryColor = "#000000";
const secondaryColor = "#000000aa";
const fontfamily = "'Poppins', sans-serif";
const appBg = "#f3f3f3";

const defaultTheme = createTheme({
  typography: {
    fontFamily: fontfamily,
  },
  palette: {
    mode: "light",
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },
  },
});
const THEMES_TYPE = {
  LIGHT: "light",
  DARK: "dark",
};

export const CustomThemeProvider = ({ children }) => {
  const [selectedTheme, setSelectedTheme] = useState(THEMES_TYPE.LIGHT);
  const [appTheme, setAppTheme] = useState(defaultTheme);

  useEffect(() => {
    updateAppBg(appBg);
    const getThemeData = async () => {
      try {
        const themeFileUrl = process.env.REACT_APP_THEME_FILE_URL;
        const res = await fetch(themeFileUrl);
        const resData = await res.json();
        if (res?.status == 200) {
          console.log("themes ", resData);
          const defaultHDORTheme = resData["default"];
          if (defaultHDORTheme) {
            const fontfamilyURL = defaultHDORTheme?.fontFamilyUrl;
            const element = document.createElement("link");
            element.setAttribute("rel", "stylesheet");
            element.setAttribute("href", fontfamilyURL);
            const headTag = document.getElementsByTagName("head");
            headTag[0].appendChild(element);
            if (defaultHDORTheme?.appBg) updateAppBg(defaultHDORTheme?.appBg);

            console.log("selectedTheme : ", selectedTheme);

            const preparedTheme = createTheme({
              palette: {
                mode: selectedTheme,
                primary: {
                  main: defaultHDORTheme?.primaryColor,
                },
                secondary: {
                  main: defaultHDORTheme?.secondaryColor,
                },
              },
              typography: {
                fontFamily: defaultHDORTheme?.fontFamily,
              },
            });

            setAppTheme(preparedTheme);
          }
        }
      } catch (error) {
        console.log("theme error : ", error);
      }
    };
    getThemeData();
  }, [selectedTheme]);

  const updateAppBg = (appBg) => {
    const headTag = document.getElementsByTagName("head");
    const bodyBgClass = document.createElement("style");
    bodyBgClass.append(`body {background-color: ${appBg}}`);
    headTag[0].appendChild(bodyBgClass);
  };

  // const checkCurrentThemeType = () => {};

  return <ThemeProvider theme={appTheme}>{children}</ThemeProvider>;
};
